"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomepageVideo = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const plyr_1 = __importDefault(require("plyr"));
class HomepageVideo {
    constructor(element) {
        var _a, _b;
        this.element = null;
        this.preview = null;
        this.play_icon = null;
        this.video_consent = null;
        this.video_player_container = null;
        this.video_player = null;
        this.provider = '';
        this.url = '';
        this.element = element;
        if (!element || element.length === 0)
            return;
        this.provider = (_a = (0, cash_dom_1.default)(element).attr('data-video-provider')) !== null && _a !== void 0 ? _a : '';
        this.url = (_b = (0, cash_dom_1.default)(element).attr('data-video-url')) !== null && _b !== void 0 ? _b : '';
        this.preview = (0, cash_dom_1.default)('.preview', element);
        this.play_icon = (0, cash_dom_1.default)('.play-icon', element);
        this.video_consent = (0, cash_dom_1.default)('.video-consent', element);
        this.video_player_container = (0, cash_dom_1.default)('.video-player', element);
        if (!this.provider || !this.url)
            return;
        this._init();
    }
    _init() {
        if (this._isConsented()) {
            this._showPlayer(false);
        }
        else {
            this.play_icon.on('click', () => this._onPlayClick());
        }
    }
    _isConsented() {
        const cookie = js_cookie_1.default.get(`external-${this.provider}`);
        return !!cookie && cookie.length >= 3;
    }
    _onPlayClick() {
        this.video_consent.show();
        (0, cash_dom_1.default)('.accept', this.video_consent).on('click', () => {
            js_cookie_1.default.set(`external-${this.provider}`, new Date().toJSON(), { expires: 120 });
            this.video_consent.hide();
            this._showPlayer(true);
        });
    }
    _showPlayer(autoplay) {
        this.preview.hide();
        this.video_player_container.show();
        if (!this.video_player) {
            this.video_player = new plyr_1.default('#homepagevideo');
        }
        if (autoplay) {
            setTimeout(() => { var _a; (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.play(); }, 500);
        }
    }
}
exports.HomepageVideo = HomepageVideo;
